// extracted by mini-css-extract-plugin
module.exports = {"tabsHeadContainer":"Tabs_tabsHeadContainer__24KkB","tabTitle":"Tabs_tabTitle__2tuNX","active":"Tabs_active__2hPHG"};